import { InjectionToken } from '@angular/core';
import { Env } from './env';

export const ENV = new InjectionToken<Env>('ENV');
